import { Battle, BATTLE_STATUS, BATTLE_STATUS_NAME } from "../../interfaces";
import { textGradient, COLOR } from "../../common/css/colors";

import "../../styles/battle.css";

export const BattleEntry = ({
    battle,
    remove,
}: {
    battle: Battle;
    remove: () => void;
}) => {
    const dateOf = new Date(battle.dateOf + " UTC");

    const options: Intl.DateTimeFormatOptions = {
        month: "short",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    };

    let statusGradient: Record<string, string> = {};
    switch (battle.status) {
        case BATTLE_STATUS.DEFEAT:
            statusGradient = textGradient(COLOR.pink5, COLOR.red);
            break;
        case BATTLE_STATUS.VICTORY:
            statusGradient = textGradient(COLOR.green, COLOR.lime1);
            break;
        case BATTLE_STATUS.ONGOING:
            statusGradient = textGradient(COLOR.orange, COLOR.yellow);
            break;
    }

    return (
        <div className="battleEntry">
            <div
                style={{
                    marginRight: "0.5em",
                    ...statusGradient,
                    width: "4em",
                }}
            >
                {BATTLE_STATUS_NAME[battle.status]}
            </div>
            <div style={{ marginRight: "0.5em", width: "10.5em" }}>
                {dateOf.toLocaleString("en-US", options) + ":"}
            </div>
            <div className="desc">{battle.desc}</div>

            <div className="deleteBattleBtn" onClick={() => remove()}>
                &otimes;
            </div>
        </div>
    );
};
